<template>
    <div v-route-title="data?data.IR_URLTITLE:'公司舆情信息'">
        <div class="yq-company-alarm-news" v-if="data">
            <div class="yq-company-alarm-news-title">{{data.IR_URLTITLE}}</div>
            <div class="yq-company-alarm-news-fields">
                <div class="yq-company-alarm-news-field">来源：{{data.IR_SITENAME}}</div>
                <div class="yq-company-alarm-news-field">{{data.IR_URLDATE}}</div>
            </div>
            <div class="yq-company-alarm-news-content" v-html="formattedContent"></div>
            <div class="yq-company-alarm-news-foot">
                <a class="yq-company-alarm-news-link" :href="(data.IR_URLNAME.indexOf('://')===-1?'http://':'')+data.IR_URLNAME" target="_blank">查看原文</a>
            </div>
        </div>
    </div>
</template>

<script>
    import companyMonitorService from '../service/company_monitor'
    import htmlUtils from '../service/html-utils'

    export default {
        name: "CompanyAlarmNews",
        props: {
            id: String
        },
        data(){
            return {
                data: null
            }
        },
        created(){
            companyMonitorService.getNews(this.id).then(response=>{
                this.data = response.data
            })
        },
        computed:{
            formattedContent(){
                if(this.data&&this.data.IR_CONTENT){
                    const content = this.data.IR_CONTENT
                    const pattern = /<[^>]+>/g
                    let arr
                    let prevEnd = 0
                    const result = []
                    while((arr = pattern.exec(content)) !== null){
                        content.substring(prevEnd, arr.index).split(/\r?\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                        result.push(arr[0])
                        prevEnd = pattern.lastIndex
                    }
                    if(prevEnd < content.length){
                        content.substring(prevEnd).split(/\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                    }
                    return result.join('')
                }else{
                    return ''
                }
            }
        }
    }
</script>

<style scoped>

</style>
